import React from 'react';
import { useSelector } from 'react-redux';

import { ProductCount } from 'src/components/atoms/ProductCount/ProductCount';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';

/** Renders nothing with no results, where the page shows its own empty state instead. */
export const ProductCountContainer = () => {
  const totalProducts = useSelector(selectTotalProducts);

  return totalProducts > 0 ? <ProductCount count={totalProducts} /> : null;
};
